import React, { useState,useRef } from "react";
import {
  Card,
  Box,
  Heading,
  Button,
  CardHeader,
  CardBody,
  CardFooter,
  useDisclosure,
  Drawer,
  DrawerContent,
  DrawerOverlay,
  DrawerCloseButton,
  DrawerHeader,
  DrawerBody,
  FormControl,
  FormLabel,
  Input,
  DrawerFooter,
  Select,
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  Grid,
  Textarea,
  Image,
  Spinner,
} from "@chakra-ui/react";
import { Flex, Text } from "@chakra-ui/react";
import { Link } from "react-router-dom";
import axios from "axios";
// import { toast } from "react-toastify";

import { Cell, LedgerRow, RowActions, StatusMark } from "../../../components/ui";

function AstroCard({ User, Update, Delete }) {
  // const { isOpen, onOpen, onClose } = useDisclosure();
  //research
  const {
    isOpen: isOpenModal1,
    onOpen: onOpenModal1,
    onClose: onCloseModal1,
  } = useDisclosure();//research->to be changed as only view
  const {
    isOpen: isOpenEditApoi1,
    onOpen: onOpenEditApoi1,
    onClose: onCloseEditApoi1,
  } = useDisclosure();//research
  const initialRef = useRef(null);
  const [formData, setFormData] = useState({});
  const finalRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  // const [appointmentStatus, setAppointmentStatus] = useState("");
  const [isDeleteAlertOpen, setIsDeleteAlertOpen] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name === "image") {
      let imageD = e.target.files[0];
      setFormData((prevFormData) => ({
        ...prevFormData,
        [name]: imageD,
      }));
    } else if (name === "DOB") {
      // Reformat the date value to "dd/mm/yyyy"
      const [year, month, day] = value.split("-");
      const formattedDate = `${day}/${month}/${year}`;
      //   console.log(value)
      setFormData((prevFormData) => ({
        ...prevFormData,
        [name]: formattedDate,
      }));
    } else {
      setFormData((prevFormData) => ({
        ...prevFormData,
        [name]: value,
      }));
    }
  };

  const onSubmitUpdate = async (formData, id) => {
    if (formData.image) {
      let imageUrl = "";
      try {
        const imageData = new FormData();
        imageData.append("file", formData.image);
        imageData.append("upload_preset", "tekxwxfz"); // Replace with your Cloudinary unsigned upload preset

        const response = await axios.post(
          `https://api.cloudinary.com/v1_1/dzidj8k7j/auto/upload`,
          imageData
        );
        imageUrl = response.data.secure_url;
        Update({ ...formData, image: imageUrl }, id);

        // toast({
        //   title: "Astro updated",
        //   description: "Your astro update successfully.",
        //   status: "success",
        //   duration: 5000,
        //   isClosable: true,
        // });
        onCloseEditApoi1();
        setFormData({});
      } catch (error) {
        console.error(error);
        return;
      }
    } else {
      Update(formData, id);
      // toast({
      //   title: "Astro updated",
      //   description: "Your astro update successfully.",
      //   status: "success",
      //   duration: 5000,
      //   isClosable: true,
      // });
      onCloseEditApoi1();
      setFormData({});
    }
  };

  return (
    <LedgerRow stripe={User.paymentStatus ? "paid" : "unpaid"}>
        <Cell full>
          <Text fontWeight={600}>{User.fname} {User.lname}</Text>
          <Text fontSize="sm" color="stone.500">{User.phone}</Text>
        </Cell>
        <Cell label="Date of birth">{User.DOB}</Cell>
        <Cell label="Submitted">{User.horoDate}</Cell>
        <Cell label="Status"><Flex direction="column" align="flex-start" gap={1}><StatusMark status={User.horoStatus} /><StatusMark status={User.paymentStatus ? "Paid" : "Unpaid"} /></Flex></Cell>
        <Cell full>
          <RowActions>
            <Button variant="outline" size="sm" onClick={onOpenModal1}>View</Button>
            <Button as={Link} to={`/admin/usersDtails/${User.userId}`} variant="outline" size="sm">User</Button>
            <Button variant="outline" size="sm" onClick={onOpenEditApoi1}>Edit</Button>
            <Button variant="danger" size="sm" onClick={() => setIsDeleteAlertOpen(true)}>Delete</Button>
          </RowActions>
        </Cell>

      <AlertDialog
        isOpen={isDeleteAlertOpen}
        leastDestructiveRef={finalRef}
        onClose={() => setIsDeleteAlertOpen(false)}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Delete Confirmation
            </AlertDialogHeader>

            <AlertDialogBody>
              Are you sure you want to delete this Astro?
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button variant="ghost"
                ref={finalRef}
                onClick={() => setIsDeleteAlertOpen(false)}
              >
                Cancel
              </Button>
              <Button variant="dangerSolid"
                onClick={() => {
                  setIsDeleteAlertOpen(false);
                  Delete(User._id);
                }}
                ml={3}
              >
                Delete
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>

      <Drawer
        initialFocusRef={initialRef}
        finalFocusRef={finalRef}
        isOpen={isOpenModal1}
        onClose={onCloseModal1}
        size="lg"
      >
        <DrawerOverlay />
        <DrawerContent>
          <DrawerHeader
          >
            Astro Details
          </DrawerHeader>
          <DrawerCloseButton />
          <DrawerBody pb={6}>
            <Grid
              templateColumns={{ base: "1fr", md: "1fr 1fr" }}
              gap={4}
            >
              <FormControl>
                <FormLabel>Full Name</FormLabel>
                <Box>{`${User.fname} ${User.lname ? User.lname : ""}`}</Box>
              </FormControl>
              <FormControl>
                <FormLabel>Mobile number</FormLabel>
                <Box>{User.phone}</Box>
              </FormControl>
              <FormControl>
                <FormLabel>Email</FormLabel>
                <Box>{User.email}</Box>
              </FormControl>

              <FormControl>
                <FormLabel>Nakshatram</FormLabel>
                <Box>{User.nakshatra}</Box>
              </FormControl>

              <FormControl>
                <FormLabel>Date Of Birth</FormLabel>
                <Box>{User.DOB}</Box>
              </FormControl>
              <FormControl>
                <FormLabel>Time Of Birth</FormLabel>
                <Box>{User.TOB}</Box>
              </FormControl>

              <FormControl>
                <FormLabel>Place Of Birth</FormLabel>
                <Box>{User.POB}</Box>
              </FormControl>
              <FormControl>
                <FormLabel>Astro Status</FormLabel>
                <Box>{User.horoStatus}</Box>
              </FormControl>

              <FormControl>
                <FormLabel>Amount</FormLabel>
                <Box>{User.ammount}</Box>
              </FormControl>
              <FormControl>
                <FormLabel>Payment Status</FormLabel>
                <Box>
                  {User.paymentStatus ? (
                    <span style={{ color: "green" }}>Paid</span>
                  ) : (
                    <span style={{ color: "red" }}>Not Paid</span>
                  )}
                </Box>
              </FormControl>
              <FormControl>
                <FormLabel>City</FormLabel>
                <Box>{User.city ? User.city : "Not recorded"}</Box>
              </FormControl>
              <FormControl>
                <FormLabel>Submission Date</FormLabel>
                <Box>{User.horoDate}</Box>
              </FormControl>

              <FormControl>
                <FormLabel>Reference</FormLabel>
                <Box>{User.referedby ? User.referedby : "Not recorded"}</Box>
              </FormControl>

              <FormControl>
                <FormLabel>Occupation</FormLabel>
                <Box>{User.occupation ? User.occupation : "Not recorded"}</Box>
              </FormControl>

              
              <FormControl
                gridColumn="1 / -1"
                width="100%"
              >
                <FormLabel>Full address</FormLabel>
                <Box>{`${User.address}`}</Box>
              </FormControl>

              <FormControl
                gridColumn="1 / -1"
                width="100%"
              >
                <FormLabel>Message</FormLabel>
                <Box>{User.message}</Box>
              </FormControl>

              <FormControl
                gridColumn="1 / -1"
                width="100%"
              >
                <FormLabel>Author Message</FormLabel>
                <Box name="fname">{User.authorMessage}</Box>
              </FormControl>
              <FormControl
                gridColumn="1 / -1"
              >
                <FormLabel>Astro Image</FormLabel>
                <Image
                  src={
                    User.image
                      ? User.image
                      : "https://t4.ftcdn.net/jpg/04/73/25/49/360_F_473254957_bxG9yf4ly7OBO5I0O5KABlN930GwaMQz.jpg"
                  }
                />
              </FormControl>
            </Grid>
          </DrawerBody>
        </DrawerContent>
      </Drawer>

      <Drawer
        initialFocusRef={initialRef}
        finalFocusRef={finalRef}
        isOpen={isOpenEditApoi1}
        onClose={onCloseEditApoi1}
        size="lg"
      >
        <DrawerOverlay />
        <DrawerContent>
          <DrawerHeader
          >
            Edit Astro
          </DrawerHeader>
          <DrawerCloseButton />
          <DrawerBody pb={6}>
            <Grid
              templateColumns={{ base: "1fr", md: "1fr 1fr" }}
              gap={4}
            >
              <FormControl>
                <FormLabel>First name</FormLabel>
                <Input
                  name="fname"
                  ref={initialRef}
                  placeholder={User.fname}
                  onChange={handleInputChange}
                  value={formData.fname}
                />
              </FormControl>

              <FormControl>
                <FormLabel>Last name</FormLabel>
                <Input
                  name="lname"
                  placeholder={User.lname}
                  onChange={handleInputChange}
                  value={formData.lname}
                />
              </FormControl>

              <FormControl>
                <FormLabel>Email</FormLabel>
                <Input
                  name="email"
                  placeholder={User.email}
                  onChange={handleInputChange}
                  value={formData.email}
                />
              </FormControl>

              <FormControl>
                <FormLabel>Nakshatram</FormLabel>
                <Input
                  name="nakshatra"
                  placeholder={User.nakshatra}
                  onChange={handleInputChange}
                  value={formData.nakshatra}
                />
              </FormControl>
              <FormControl>
                <FormLabel>Date Of Birth</FormLabel>
                <Input
                  type="date"
                  border="1px solid black"
                  name="DOB"
                  placeholder={User.DOB}
                  onChange={handleInputChange}
                  // value={formData.DOB}
                />
              </FormControl>

              <FormControl>
                <FormLabel>Time Of Birth</FormLabel>
                <Input
                  name="TOB"
                  type="time"
                  placeholder={User.TOB}
                  onChange={handleInputChange}
                  value={formData.TOB}
                />
              </FormControl>

              <FormControl>
                <FormLabel>Place Of Birth</FormLabel>
                <Input
                  name="POB"
                  type="text"
                  value={formData.POB || User.POB}
                  onChange={handleInputChange}
                  defaultValue={User.POB}
                />
              </FormControl>

              <FormControl>
                <FormLabel>Asto Status</FormLabel>
                <Select
                  name="horoStatus"
                  value={formData.horoStatus || User.horoStatus}
                  onChange={handleInputChange}
                >
                  <option value="Pending">Pending</option>
                  <option value="Completed">Completed</option>
                </Select>
              </FormControl>
              <FormControl>
                <FormLabel>Payment</FormLabel>
                <Select
                  name="paymentStatus"
                  value={formData.paymentStatus || User.paymentStatus}
                  onChange={handleInputChange}
                  defaultValue={User.paymentStatus ? "paid" : "notPaid"}
                >
                  <option value={false}>Not Paid</option>
                  <option value={true}>Paid</option>
                </Select>
              </FormControl>
              <FormControl>
                <FormLabel>Amount</FormLabel>
                <Input
                  placeholder={User.ammount}
                  name="ammount"
                  type="number"
                  onChange={handleInputChange}
                  value={formData.ammount}
                />
              </FormControl>
              <FormControl
                width="100%"
              >
                <FormLabel>Upload Image</FormLabel>
                
                <Input
                  type="file"
                  id="imageMobile"
                  name="image"
                  accept="image/*"
                  onChange={handleInputChange}
                  required
                />
              </FormControl>
              <FormControl>
                <FormLabel>City</FormLabel>
                <Input
                  placeholder={User.city}
                  name="city"
                  onChange={handleInputChange}
                  value={formData.city}
                />
              </FormControl>

              <FormControl>
                <FormLabel>Reference</FormLabel>
                <Input
                  name="referedby"
                  defaultValue={User.referedby}
                  onChange={handleInputChange}
                  value={formData.referedby}
                />
              </FormControl>

              <FormControl>
                <FormLabel>Occupation</FormLabel>
                <Input
                  name="occupation"
                  defaultValue={User.occupation}
                  onChange={handleInputChange}
                  value={formData.occupation}
                />
              </FormControl>
             
              <FormControl
                gridColumn="1 / -1"
                width="100%"
              >
                <FormLabel>Full address</FormLabel>
                <Textarea
                  name="address"
                  defaultValue={User.address}
                  onChange={handleInputChange}
                  value={formData.address}
                />
              </FormControl>

              <FormControl
                gridColumn="1 / -1"
              >
                <FormLabel>Author Message</FormLabel>
                <Textarea
                  rows={6}
                  defaultValue={User.authorMessage}
                  name="authorMessage"
                  onChange={handleInputChange}
                  value={formData.authorMessage}
                />
              </FormControl>

              {/* <FormControl gridColumn={{ base: "1 / span 2", md: "auto" }}>
                  <FormLabel>Upload Image</FormLabel>
                 
                  <Input
                        type="file"
                        id="imageMobile"
                        name="image"
                        accept="image/*"
                        onChange={ handleInputChange}
                        required
                    />
                </FormControl> */}
            </Grid>
          </DrawerBody>

          <DrawerFooter>
            <Button
              mr={3}
              onClick={() => {
                setIsLoading(true); // Set isLoading to true when the button is clicked
                onSubmitUpdate(formData, User._id).finally(() =>
                  setIsLoading(false)
                ); // Reset isLoading to false after the update is complete or if there's an error
              }}
            >
              {isLoading ? <Spinner size="sm" color="white" /> : "Save"}
            </Button>
            <Button variant="ghost"
              onClick={onCloseEditApoi1}
            >
              Cancel
            </Button>
          </DrawerFooter>
        </DrawerContent>
      </Drawer>
    </LedgerRow>
  );
}

export default AstroCard;
